type FeatureFlagsState = Record<string, any>;

// those feature flags are defined here because we're using them directly in selectors
// if you want to access a feature flag inside a react component just use `useFlags` hook
const defaultState: FeatureFlagsState = {
    who5ScoreThresholdForTherapy: 28,
    hideRequestPersonalEmailFlowWeb: false,
    workEmailAddressChangeRequired: false,
    hideReTriageFlow: false,
    translationUi: false,
};

export const featureFlags = {
    state: defaultState,
    reducers: {
        saveFlags: (state: FeatureFlagsState, newFlags: FeatureFlagsState): FeatureFlagsState =>
            newFlags
                ? {
                      ...state,
                      ...newFlags,
                  }
                : state,
    },
};
